import { usePersistedState } from './usePersistedState';

export type GranularityMode = 'auto' | 'hourly' | 'daily' | 'weekly' | 'monthly';

/** Single source of truth for the selectable modes (order = display order). */
export const GRANULARITY_MODES: GranularityMode[] = ['auto', 'hourly', 'daily', 'weekly', 'monthly'];

const STORAGE_KEY = 'peak4.admin.granularity.v1';

const deserialize = (raw: string): GranularityMode | null =>
  (GRANULARITY_MODES as string[]).includes(raw) ? (raw as GranularityMode) : null;

const serialize = (mode: GranularityMode): string => mode;

export const usePersistedGranularity = () => {
  const [granularityMode, setGranularityMode] = usePersistedState<GranularityMode>({
    storageKey: STORAGE_KEY,
    fallback: 'auto',
    deserialize,
    serialize,
  });

  return { granularityMode, setGranularityMode } as const;
};
